import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.ctaBlue(4)};
  border-radius: ${({ theme }) => theme.spacings.abs8}px;
  margin-top: ${({ theme }) => theme.spacings.abs16}px;
  padding: ${({ theme }) => theme.spacings.abs16}px;
  text-align: left;
`;
